/* eslint-disable import/no-anonymous-default-export */
const loggingBaseUrl =
  'https://dev.core-gateway.np.api-business.comcast.com/logging-api';
const loggingApiKey = 'K06lPBT0UikuQyiwW6MQ72tB9N4YORL5nWTN92O8';

export default {
  featureFlags: {
    useNewForgotPasswordEnabled: true,
  },
  fidoConfig: {
    headers: {
      'tracking-id': '',
      'x-api-key': 'rIYwDjmhEzaYwpKjeMBRF6Lu1i05OzAE1UIE76RB', // ??
    },
    dataApiConfig: {
      logging: {
        baseUrl: loggingBaseUrl,
        sensitiveFields: ['newPassword'],
      },
      passwordReset: {
        baseUrl:
          'https://password-reset-bff.pqa.np.api-business.comcast.com/passwordreset',
        sensitiveFields: ['newPassword'],
      },
    },
  },
  redirectLinks: {
    forgotEmailUrl: 'https://business.pqa.comcast.com/account/forgot-username/',
  },
  loggerConfig: {
    appSettings: {
      applicationId: 'ResetPassword',
      apiKey: loggingApiKey,
      loggingEndpoint: {
        url: '/event',
        baseURL: loggingBaseUrl,
      },
    },
    environment: 'pqa',
    visitorSessionId: '',
  },
  sessionDurationInMinutes: 20,
  globalNavConfig: {
    scriptUrl:
      'https://bsd-global-nav-ui-pqa.np.digital.business.comcast.com/globalNav.js',
    environment: 'pqa',
  },
};
